import { APP_CRITICALITIES } from "vmd-types";

import {
  CHART_ACCENT_BLUE,
  CRITICALITY_COLORS_BY_KEY,
  CRITICALITY_TEXT_COLOR,
  DC_RELEVANCE_INDICATOR_COLOR,
  DC_RELEVANCE_UNREVIEWED_COLOR,
  DISTRIBUTION_CHANNEL_OE_MATRIX_DARK_TEXT,
  DISTRIBUTION_CHANNEL_OE_MATRIX_HUE,
  DISTRIBUTION_CHANNEL_OE_MATRIX_LIGHT_TEXT,
  DISTRIBUTION_CHANNEL_OE_MATRIX_SATURATION,
  DONUT_CHART_COLORS,
  getDcRelevanceIndicator,
  getDistributionChannelOeMatrixShade,
  getReviewStatusBadgeColors,
  getReviewStatusBadgeProps,
  RECORD_TYPE_BADGE_COLORS,
  REVIEW_STATUS_BADGE_COLORS,
  RISK_HEAT_MAP_COLORS,
  SECONDARY_TEXT_COLOR,
} from "./constants/colors.ts";

export const APP_ROUTES = {
  home: "/",
  login: "/login",
  dashboard: "/dashboard",
  report: "/reports/:id/:viewname",
  findings: "/reports/:id/findings",
  overview: "/overview",
  settings: {
    notifications: "/settings/basic-notifications",
    scheduledNotifications: "/settings/scheduled-notifications",
    reportingStructure: "/settings/reporting-structure",
    reportingPeriod: "/settings/reporting-period",
    manageProjectsDataModel: "/settings/manage-projects-data-model",
    manageItemsDataModel: "/settings/manage-items-data-model",
    manageReportingData: "/settings/manage-reporting-data",
    manageMainEntities: "/settings/manage-main-entities",
    manageUsers: "/settings/manage-users",
    manageSubentities: "/settings/manage-subentities",
    manageReportingCycle: "/settings/manage-reporting-cycle",
    manageAccess: "/settings/manage-access",
    reportingUseCase: "/settings/reporting-use-case",
  },
  editReport: "/reports/:id/:viewname/edit",
  editManagementSummary: "/dashboard/edit-management-summary",
  projectDialog: "/overview/project/:id/:isFromOverview",
  trackingItemDialog: "/reports/:id/:viewname/tracking-item/:tracking-item-id",
  trackingItemDialogBlock:
    "/reports/:id/:viewname/tracking-item/:tracking-item-id/:block-code",
  logs: "/logs",
} as const;

export const RESOURCE_LOCK_POLLING_INTERVAL = 30000; // 30 seconds

export const API_ROUTES = {
  CHAT: "api/chat",
  CHAT_STATUS: "api/chat/status",
} as const;

// Reserved DragDropLayout tab id for the Findings stub tab shown on the
// Reports page. Real user-created tabs are assigned `max(existing ids)+1`
// (see drag-and-drop-layout.tsx), so this permanently-reserved id must stay
// far above any id a saved layout could realistically reach (#2413).
export const FINDINGS_TAB_ID = 999999;

export const CRITICAL_CRITICALITY_LEVELS = [
  APP_CRITICALITIES.HIGH,
  APP_CRITICALITIES.VERY_HIGH,
] as const;

// the donut card reserves no height for its header and padding, so let it size to content instead
export const DONUT_CARD_LAYOUT = {
  legendColumnMaxWidth: "280px",
  legendItemsMaxWidth: "280px",
  style: { height: "auto" },
} as const;

export {
  CHART_ACCENT_BLUE,
  CRITICALITY_COLORS_BY_KEY,
  CRITICALITY_TEXT_COLOR,
  DC_RELEVANCE_INDICATOR_COLOR,
  DC_RELEVANCE_UNREVIEWED_COLOR,
  DISTRIBUTION_CHANNEL_OE_MATRIX_DARK_TEXT,
  DISTRIBUTION_CHANNEL_OE_MATRIX_HUE,
  DISTRIBUTION_CHANNEL_OE_MATRIX_LIGHT_TEXT,
  DISTRIBUTION_CHANNEL_OE_MATRIX_SATURATION,
  DONUT_CHART_COLORS,
  getDcRelevanceIndicator,
  getDistributionChannelOeMatrixShade,
  getReviewStatusBadgeColors,
  getReviewStatusBadgeProps,
  RECORD_TYPE_BADGE_COLORS,
  REVIEW_STATUS_BADGE_COLORS,
  RISK_HEAT_MAP_COLORS,
  SECONDARY_TEXT_COLOR,
};
